import { Observable } from 'rxjs';

import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';

import { environment } from '@environments/environment';

interface ApiKeyRule {
  match: RegExp;
  apiKey: string;
}

const API_KEY_RULES: ApiKeyRule[] = [
  {
    match: /^\/api\/v1\/trusts/,
    apiKey: environment.FACILITIES_API_KEY,
  },
  {
    match: /^\/api\/v1\/onbase/,
    apiKey: environment.FACILITIES_API_KEY,
  },
  {
    match: /^\/api\/v1\/financials/,
    apiKey: environment.FINANCIALS_API_KEY,
  },
  {
    match: /^\/api\/v1\/company/,
    apiKey: environment.COMPANIES_API_KEY,
  },
  {
    match: /^\/api\/v1\/data-studio/,
    apiKey: environment.DATA_STUDIO_API_KEY,
  },
];

export function httpApiKeyInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  let pathname = '';

  try {
    pathname = new URL(req.url).pathname;
  } catch {
    pathname = req.url;
  }

  const rule = API_KEY_RULES.find(r => r.match.test(pathname));

  // LEN-2764: read per request, so an environment can stop sending the public
  // key without touching the rules.
  if (!rule || !environment.SEND_EDGE_API_KEY) {
    return next(req);
  }

  const requestWithApiKey = req.clone({
    setHeaders: {
      'x-api-key': rule.apiKey,
    },
  });

  return next(requestWithApiKey);
}
